import React, { SVGProps } from 'react';

const AccountSecurityIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="100%"
			height="100%"
			viewBox="0 0 17 17"
			fill="none"
			{...props}
		>
			<path
				d="M8.90039 1.02148L2.90039 3.68815V7.68815C2.90039 11.3882 5.46039 14.8482 8.90039 15.6882C12.3404 14.8482 14.9004 11.3882 14.9004 7.68815V3.68815L8.90039 1.02148ZM8.90039 5.02148C9.83372 5.02148 10.7671 5.75482 10.7671 6.68815V7.68815C11.1671 7.68815 11.5671 8.08815 11.5671 8.55482V10.8882C11.5671 11.2882 11.1671 11.6882 10.7004 11.6882H7.03372C6.63372 11.6882 6.23372 11.2881 6.23372 10.8215V8.48815C6.23372 8.08815 6.63372 7.68815 7.03372 7.68815V6.68815C7.03372 5.75482 7.96706 5.02148 8.90039 5.02148ZM8.90039 5.82148C8.36706 5.82148 7.90039 6.15482 7.90039 6.68815V7.68815H9.90039V6.68815C9.90039 6.15482 9.43372 5.82148 8.90039 5.82148Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default AccountSecurityIcon;
